module.exports = __webpack_public_path__ + "static/media/notSetupsvg.f496315a.svg";